import { createVanIconComponent } from "./van"

const Exchange = createVanIconComponent("exchange")
export default Exchange
